import { isSubmitting } from '../state'
import { validateForm } from './validate-form'
import { prepareData } from './prepare-data'

/**
 * Form verilerini gönderir
 * @param {Object} contentProps - İçerik özellikleri
 * @param {Function} createSuggestion - Öneri oluşturma fonksiyonu
 * @param {Function} onSuccess - Başarılı işlem sonrası çalışacak callback
 * @param {Function} onClose - Modal kapatma fonksiyonu
 * @param {Function} resetForm - Form sıfırlama fonksiyonu
 * @returns {Promise<void>}
 */
export const submitForm = async (
  contentProps,
  createSuggestion,
  onSuccess,
  onClose,
  resetForm
) => {
  // Form doğrulama
  if (!validateForm(contentProps) || isSubmitting.value) return

  try {
    isSubmitting.value = true

    // Timeout promise'i oluştur - 15 saniye içinde cevap gelmezse iptal et
    const timeoutPromise = new Promise((_, reject) =>
      setTimeout(() => reject(new Error('İşlem zaman aşımına uğradı')), 15000),
    )

    // Gönderim verilerini hazırla
    const suggestionData = prepareData(contentProps)

    // Öneriyi gönder - timeout ile yarıştır
    const response = await Promise.race([
      createSuggestion(suggestionData),
      timeoutPromise,
    ])

    // Başarı durumu
    if (response) {
      // Başarı callback'ini çağır
      if (onSuccess && typeof onSuccess === 'function') {
        onSuccess(response)
      }
      
      // Formu sıfırla ve kapat
      resetForm()
      onClose()
    }
  } catch (error) {
    console.error('Error creating suggestion:', error)

    // Zaman aşımı hatası için özel işlem
    if (error.message === 'İşlem zaman aşımına uğradı') {
      onClose() // Modalı zorla kapat
      throw new Error('Öneri gönderim işlemi zaman aşımına uğradı. Lütfen daha sonra tekrar deneyin.')
    } else {
      throw error
    }
  } finally {
    isSubmitting.value = false
  }
}